import { render, staticRenderFns } from "./account-records-table.vue?vue&type=template&id=5cf486da&scoped=true"
import script from "./account-records-table.vue?vue&type=script&lang=js"
export * from "./account-records-table.vue?vue&type=script&lang=js"
import style0 from "./account-records-table.vue?vue&type=style&index=0&id=5cf486da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf486da",
  null
  
)

export default component.exports